<svg [attr.width]="size" [attr.height]="size" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M233.337 183.336H133.337M166.67 250.003H133.337M266.67 116.669H133.337M333.337 200.003V113.336C333.337 85.3333 333.337 71.332 327.887 60.6364C323.093 51.2283 315.444 43.5793 306.036 38.7856C295.341 33.3359 281.339 33.3359 253.337 33.3359H146.67C118.667 33.3359 104.666 33.3359 93.9704 38.7856C84.5623 43.5793 76.9133 51.2283 72.1196 60.6364C66.6699 71.332 66.6699 85.3333 66.6699 113.336V286.669C66.6699 314.672 66.6699 328.673 72.1196 339.369C76.9133 348.777 84.5623 356.426 93.9704 361.22C104.666 366.669 118.667 366.669 146.67 366.669H200.003M266.67 266.669L350.003 350.003M350.003 266.669L266.67 350.003"
    stroke="currentcolor"
    stroke-width="33.3333"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
